import{useEffect as e,useState as t}from"react";var r=(r,s=500)=>{const[o,u]=t(r);return e(()=>{const e=setTimeout(()=>{u(r)},s);return()=>{clearTimeout(e)}},[r,s]),o};export{r as useDebounce};
//# sourceMappingURL=useDebounce.js.map